// extracted by mini-css-extract-plugin
module.exports = {"Checkout":"Checkout_Checkout__1OoAc","CheckoutBlock":"Checkout_CheckoutBlock__3CoMI","Button":"Checkout_Button__YO5gh","SumBlock":"Checkout_SumBlock__hk-KC"};